import { Injectable } from '@angular/core';

import { OfferCategory } from '@cds/betting-offer';
import { OfferMapping } from '@cds/query-objects';
import { FavouritesConfig } from '@frontend/sports/common/client-config-data-access';
import { UserService } from '@frontend/sports/user/feature';
import { Observable, of, tap } from 'rxjs';

import { LiveFavouriteFixturesService } from '../favourites/live-favourites-fixtures.service';
import { LiveEventListService, LiveFavouritesModel } from './live-event-list.service';

@Injectable({ providedIn: 'root' })
export class LiveFavouriteResolver {
    constructor(
        private liveEventListService: LiveEventListService,
        private liveFavouriteFixturesService: LiveFavouriteFixturesService,
        private favouritesConfig: FavouritesConfig,
        private userService: UserService,
    ) {}

    resolve(): Observable<LiveFavouritesModel | undefined> {
        if (this.favouritesConfig.isLiveFavouritesEnabled && this.userService.isAuthenticated) {
            this.liveFavouriteFixturesService.refresh(OfferMapping.Filtered, OfferCategory.Gridable);

            return this.liveEventListService.getFavourites().pipe(tap((model) => this.liveEventListService.notifyParent(model)));
        } else {
            return of(undefined);
        }
    }

    preResolve() {
        if (this.favouritesConfig.isLiveFavouritesEnabled && this.userService.isAuthenticated) {
            this.liveEventListService.getFavourites().subscribe();
        }
    }
}
